module.exports = __webpack_public_path__ + "img/policy-more.25e5a91e.png";